import './App.css';
import Layout from "./components/layout/Layout";
import { ToastProvider } from 'react-toast-notifications';
import React from "react";
//
function App() {
  return (
    <div className="App">
      <ToastProvider>
        <Layout/>
      </ToastProvider>
    </div>
  );
}

export default App;
